import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import hi from './locales/hi.json';
import kn from './locales/kn.json';
import mr from './locales/mr.json';
import te from './locales/te.json';
import bn from './locales/bn.json';
import gu from './locales/gu.json';
import ml from './locales/ml.json';
import ta from './locales/ta.json';
import { getLocalStorageItem } from './common/LocalStorageService';

const getLanguage = () => {
  const user = getLocalStorageItem("userData") || getLocalStorageItem("language");
  return user?.lang_code || 'en';
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    hi: { translation: hi },
    kn: { translation: kn },
    mr: { translation: mr },
    te: { translation: te },
    bn: { translation: bn },
    gu: { translation: gu },
    ml: { translation: ml },
    ta: { translation: ta },
  },
  lng: getLanguage(), // Default language
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes by default
  },
});

export default i18n;